import { request } from '../request';
import { PlotData } from './interfaces';

export const plotDetails = (uuid: string): Promise<PlotData> => {
  return request('GET', `/api/v2/plots/${uuid}/`, {}, { injectTenant: true, version: 2 });
};
